module.exports = "<fuse-navigation layout=\"horizontal\"></fuse-navigation>\n"


//////////////////
// WEBPACK FOOTER
// /usr/app/src/app/main/navbar/horizontal/navbar-horizontal.component.html
// module id = ../../../../../src/app/main/navbar/horizontal/navbar-horizontal.component.html
// module chunks = main